export default "__VITE_ASSET__N$TJc8B0__"